/*
 * @Author: luting
 * @Date: 2022-04-19 18:54:08
 * @lastEditors: luting
 * @LastEditTime: 2023-05-30 17:06:39
 */
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Tooltip } from 'sup-ui';

import messages from '../messages';
import Icon from 'root/components/Icon';
import empty from 'root/assets/images/illustrator_empty2.png';
import { Tag, Spin } from 'sup-ui';

import styles from '../index.less';

interface IProps {
  handleDelete: (archiveId: string, viewId: string) => void;
  handleReset: (viewId: string) => void;
  handleCancel: (viewId: string) => void;
  handleUnzip: (id: string, viewId: string, catalog: string) => void;
}

const UPLOADSTATUS = [
  'UPLOAD_SUCCESS',
  'UPLOAD_FAIL',
  'UPLOADING',
  'NONE_UPLOAD',
  'UNZIPING',
  'UPLOAD_SUCCESS',
  'UNZIP_FAILED',
]; // unziping 为前端控制正在加压中状态

const PackDetail = (props: IProps) => {
  const intl = useIntl();
  const { handleDelete,handleReset, handleCancel, handleUnzip } = props;
  const { queueState } = useSelector((state: any) => state.packManage);
  const [dataSource, setDataSource] = useState<any>([]);
  const [stowList, setStowList] = useState<any>([]);
  const tagType: { [propsName: string]: string } = {
    system: intl.formatMessage(messages.systemPack),
    extension: intl.formatMessage(messages.extensionPack),
    middleware: intl.formatMessage(messages.middlewarePack),
    app: 'APP',
    bucket: intl.formatMessage(messages.bucketPack),
  };

  useEffect(() => {
    if (!queueState.length) return;

    const obj = _.groupBy(queueState, 'catalog');
    const catelogList: any = [];
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        // 最终需要的数据
        const tempArr: any = {
          catalog: key,
          list: [],
        };
        // 循环每个分类，将的detail数据拉平并将外层数据添加给单条数据
        obj[key].forEach((item: any, index: number) => {
          tempArr.list.push({
            ...item,
            border: index === obj[key].length - 1 ? 'solid' : 'dashed',
          });
        });
        catelogList.push(tempArr);
      }
    }
    setDataSource(catelogList);
  }, [queueState]);

  const updateStow = (catalog: string) => {
    let tempObj = [...stowList];

    if (tempObj.includes(catalog)) {
      tempObj = tempObj.filter((ele: string) => ele !== catalog);
    } else {
      tempObj.push(catalog);
    }

    setStowList(tempObj);
  };

  const renderOperate = (parmas: any, catalog: string) => {
    const { uploadStatus, uploadPrecent, archiveId, viewId } = parmas;

    const type = UPLOADSTATUS[uploadStatus];
    switch (type) {
      case 'UPLOAD_SUCCESS':
        return (
          <>
            {catalog === 'bucket' && (
              <span onClick={() => handleUnzip(archiveId, viewId, catalog)}>
                {intl.formatMessage(messages.decompression)}
              </span>
            )}
            <span style={{ paddingLeft: 10 }} onClick={() => handleDelete(archiveId, viewId)}>
              {intl.formatMessage(messages.delete)}
            </span>
          </>
        );
      case 'UNZIPING':
        return (
          <>
            <Spin size="small" spinning={uploadStatus === 'UNZIPING'} />
            <span>{intl.formatMessage(messages.decompressioning)}</span>
          </>
        );
      case 'UPLOADING':
        return (
          <>
            <span>{intl.formatMessage(messages.uploading)}</span>
            <span style={{width: 60, display:'inline-block', padding: '0 10px' }}>{uploadPrecent}%</span>
            <span
              style={{ cursor: 'pointer' }}
              onClick={() => {
                handleCancel(viewId);
              }}
            >
              {intl.formatMessage(messages.cancel)}
            </span>
          </>
        );
      case 'UPLOAD_FAIL':
        return (
          <>
            <span onClick={() => handleDelete(archiveId, viewId)}>{intl.formatMessage(messages.delete)}</span>
            <span  style={{ paddingLeft: 12 }} onClick={() => handleReset(viewId)}>{intl.formatMessage(messages.reset)}</span>
          </>
          );

      case 'UNZIP_FAILED':
        return (
          <>
            {catalog === 'bucket' && (
              <span onClick={() => handleUnzip(archiveId, viewId, catalog)}>
                {intl.formatMessage(messages.decompression)}
              </span>
            )}
            <span style={{ paddingLeft: 10 }} onClick={() => handleDelete(archiveId, viewId)}>
              {intl.formatMessage(messages.delete)}
            </span>
          </>
        );

      default:
        return null;
    }
  };

  const renderMessage = (parmas: any) => {
    const { uploadStatus, uploadTime, uploadDetail } = parmas;
    const type = UPLOADSTATUS[uploadStatus];
    switch (type) {
      case 'UPLOAD_SUCCESS':
      case 'UNZIPING':
        return (
          <div>
            {intl.formatMessage(messages.uploadTime)}：
            {moment(uploadTime).format(
              `YYYY[${intl.formatMessage(messages.year)}]M[${intl.formatMessage(messages.month)}]D[${intl.formatMessage(
                messages.day,
              )}] HH:mm`,
            ) || '-'}
          </div>
        );
      case 'UPLOAD_FAIL':
        return (
          <Tooltip title={uploadDetail}>
            <span className={styles.failReson}>{intl.formatMessage(messages.uploadFail)}</span>
            <Icon type="help16" style={{ fontSize: 16, color: '#D20C0C' }} />
          </Tooltip>
        );
      default:
        return null;
    }
  };

  return dataSource.map((item: any, parentIdx: number) => (
    <div className={styles.pack_detail} key={item.catalog + parentIdx}>
      <div className={styles.pack_title} onClick={() => updateStow(item.catalog)}>
        {tagType[item.catalog] || intl.formatMessage(messages.notCatalog)}({item.list.length})
        <Icon type={stowList.includes(item.catalog) ? 'bluearrow16_up' : 'bluearrow16_down'} />
      </div>
      {item.list.map((ele: any, index: number) => (
        <div
          key={index}
          className={`${parentIdx === dataSource.length - 1 ? '' : styles.shadow} `}
          style={{ display: stowList.includes(item.catalog) ? 'none' : 'block' }}
        >
          <div
            className={styles.pack_info}
            style={{
              borderBottom: `1px ${
                parentIdx === dataSource.length - 1 && index === item.list.length - 1 ? 'solid' : ele.border
              } #DBE2E9`,
            }}
          >
            <div className={styles.info}>
              <img className={styles.img} src={ele.img ? ele.img : empty} alt="" />
              <div className={styles.infoTitle}>
                <p
                  className={styles.title}
                  style={{ textDecoration: ele.uploadStatus === 1 ? 'line-through' : 'none' }}
                >
                  {ele.title}
                </p>
                <div className={styles.subTitle}>
                  {intl.formatMessage(messages.version)}：{ele.version}
                  {item.catalog !== 'bucket' && (
                    <Tag color="blue">
                      {ele.type === 1
                        ? intl.formatMessage(messages.fullPackage)
                        : intl.formatMessage(messages.patchPackage)}
                    </Tag>
                  )}
                </div>
              </div>
              <div className={styles.messageInfo}> {renderMessage(ele)}</div>
              <div className={styles.operateBtn}>{renderOperate(ele, item.catalog)}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  ));
};

export default PackDetail;
